import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import StoryHero from "../components/story/StoryHero";
import MeshMoment from "../components/story/MeshMoment";
import StepsSection from "../components/story/StepsSection";
import LoopMarquee from "../components/story/LoopMarquee";
import TrustAct from "../components/story/TrustAct";
import FounderFilm from "../components/story/FounderFilm";
import BelongingAct from "../components/story/BelongingAct";
import DownloadAct from "../components/story/DownloadAct";
import JoinBar from "../components/story/JoinBar";

// The story-site revamp (LL-0199), served at /next.
//
// Deliberately a SEPARATE route rather than a replacement for Home: the live
// home page keeps working untouched while this is reviewed, so nothing has to
// be reverted if the direction changes, and both can be compared side by side
// in the same build. Swapping it in later is a one-line route change.
//
// All six acts of the arc are now present: invitation, mesh, mechanism, proof,
// belonging, ask. The page ends on the wordmark rather than on the shared site
// footer, because the closing wordmark IS this page's sign-off.
//
// NOT INDEXED. The route carries noSitemap: true in scripts/prerender.mjs,
// which both keeps it out of sitemap.xml and injects the noindex robots tag
// into the PRERENDERED html. It is deliberately not done here in an effect: a
// crawler reads the served static file before any effect runs, so a
// client-injected robots tag would be invisible to exactly the audience it is
// meant to stop.

const StoryHomePage: React.FC = () => {
  useEffect(() => {
    document.title = "LetsLoop | Find the people you mesh with";
  }, []);

  return (
    <>
      <Navbar />
      <StoryHero />
      <MeshMoment />
      <StepsSection />
      <LoopMarquee />
      <TrustAct />
      {/* The film sits between the trust argument and the belonging payoff:
          having just claimed the thing is safe, this is who is claiming it. */}
      <FounderFilm />
      <BelongingAct />
      {/* DownloadAct is this site's footer: the teal ground, the store CTAs,
          the wordmark sign-off and now the legal strip. Nothing may sit below
          it. The company evidence used to, which read as a section stranded
          under the footer; it moved to /about, where it has room for the team
          and reads as a page rather than an appendix. */}
      <DownloadAct />
      <JoinBar />
    </>
  );
};

export default StoryHomePage;
